<script setup>
 import {usePortalContentAndDesignStore} from "../../stores/partners/portalContentAndDesignStore";
 import {ref, computed} from "vue";
 import EditableTextField from "./portal-editable-fields/EditableTextField.vue";
 import EditableBtn from "./portal-editable-fields/EditableBtn.vue";
 import ValidationErrors from "../common/ValidationErrors.vue";

     const portalContentAndDesignStore = usePortalContentAndDesignStore();

     const emit = defineEmits(['modal-off']);

     const updateUrl = route('partners_int.custom_links.update');

     const updateRefLinkModal = ref(null)

     const props = defineProps({
         partnerCustomLink: {
             type: Object,
             required: true
         }
    })


    const error = ref(null)
    const loading = ref(false)
    const custom_link = ref(JSON.parse(JSON.stringify(props.partnerCustomLink)));
    const custom_link_backup = ref(JSON.parse(JSON.stringify(props.partnerCustomLink)));

    const updateCustomLink = () => {
            error.value = null;
            loading.value = true;

            axios
                .post(updateUrl, {link_id: custom_link.value.id, key: custom_link.value.key})
                .then(response => {
                    if (+response.data.status === 1) {
                        if (updateRefLinkModal.value) {
                            updateRefLinkModal.value.showModal = false;
                        }
                        portalContentAndDesignStore.resourcesPageSettings.custom_links = portalContentAndDesignStore.resourcesPageSettings.custom_links.map(link => {
                            if (link.id === custom_link.value.id) {
                                return {...link, key: custom_link.value.key};
                            }
                            return link;
                        });
                        emit('modal-off', 'partner_update_custom_link');
                    } else {
                        error.value = response.data?.error || response.data?.errors || 'Failed to update custom link';
                    }
                })
                .catch(resError => {
                    if (resError.response && resError.response.status === 422) {
                        error.value = resError.response?.data?.errors || 'Something went wrong';
                    } else {
                        console.log('Creating link error:', error.response);
                        error.value = resError.response?.data?.error || 'An error occurred. See console for details.';
                    }
                }).finally(() => loading.value = false);
    }

    const modalClose = () => {
            custom_link.value = {...custom_link_backup.value};
    }

    // Split the original URL around its key so the base can be shown as a muted,
    // non-editable prefix/suffix while only the key remains editable inline.
    const linkParts = computed(() => {
        const url = custom_link_backup.value.url ?? '';
        const backupKey = custom_link_backup.value.key ?? '';
        const idx = backupKey ? url.lastIndexOf(backupKey) : -1;
        if (idx === -1) {
            return {prefix: url, suffix: ''};
        }
        return {prefix: url.slice(0, idx), suffix: url.slice(idx + backupKey.length)};
    });
    const linkPrefix = computed(() => linkParts.value.prefix);
    const linkSuffix = computed(() => linkParts.value.suffix);
</script>
<template>
    <modal
       :title="portalContentAndDesignStore.translationSettings.portal_translation_features_referral_url"
       :cancel_btn_title="portalContentAndDesignStore.translationSettings.portal_translation_general_cancel"
       size="small"
       name="partner_update_custom_link"
       @modalClose="modalClose"
       ref="updateRefLinkModal"
    >
        <template #toggle>
            <options-item
                :title="portalContentAndDesignStore.translationSettings.portal_translation_features_update_ref_url"></options-item>
        </template>
        <template #body>
            <div class="space-y-4">
                <validation-errors :errors="error" />
                <div>
                    <editable-text-field
                        text-type="label"
                        for-attribute="custom_link_key"
                        v-model="portalContentAndDesignStore.translationSettings.portal_translation_features_link_key"
                        class="block text-gray-900 text-sm mb-1.5"
                    />
                    <!-- The whole referral link reads as a single input: the base URL is a
                         muted prefix/suffix and only the key is editable inline. -->
                    <div class="flex items-center w-full rounded border border-gray-300 bg-white sm:text-sm focus-within:border-gray-400">
                        <span class="min-w-0 truncate py-2 pl-3 text-gray-400">{{ linkPrefix }}</span>
                        <input type="text"
                               v-model="custom_link.key"
                               id="custom_link_key"
                               name="custom_link_key"
                               class="min-w-0 flex-1 border-0 bg-transparent py-2 pl-0 text-gray-900 sm:text-sm focus:ring-0"
                               :class="linkSuffix ? 'pr-0' : 'pr-3'"
                               @keyup.enter="updateCustomLink"
                        >
                        <span v-if="linkSuffix" class="whitespace-nowrap py-2 pr-3 text-gray-400">{{ linkSuffix }}</span>
                    </div>
                </div>
            </div>
        </template>
        <template #footer>
            <editable-btn
                v-on:click="updateCustomLink"
                :loading="loading"
                :disabled="loading"
                v-model="portalContentAndDesignStore.translationSettings.portal_translation_general_update"
            />
        </template>
    </modal>
</template>
